import { render } from "./VisitorKioskSettings.vue?vue&type=template&id=0cdc2e9e"
import script from "./VisitorKioskSettings.vue?vue&type=script&lang=js"
export * from "./VisitorKioskSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__